import React from "react";
import Nav from 'react-bootstrap/Nav';
import {useHistory} from 'util/router'

function BackButton(props) {
    const history = useHistory()
    return (
        <div className={props.className}>
            <Nav.Link
            onClick={() => history.goBack()}
            className="primaryColor pl-0"
            >
                <i className="fas fa-angle-left mr-2"></i>
                BACK
            </Nav.Link>
        </div>
    )
}

export default BackButton
